import React from 'react'

import SettingsPage from '../SettingsPage'
import CustomerStatusSettings from './CustomerStatusSettings'
import CustomerTypeSettings from './CustomerTypeSettings'

const UserSettings = () => {
  return (
    <SettingsPage title='Users'>
      <CustomerStatusSettings />

      <CustomerTypeSettings />
    </SettingsPage>
  )
}

export default UserSettings
